<!-- Swing CardContent.vue, fixed commit f0b87657c6450dc12d2dfd286b75f501410dcabd,
     MIT / Mungai Njoroge. Skeleton structure retained; only shown during a real load. -->
<template>
  <div class="card-placeholder" :class="{ with_helptext: withHelptext }" aria-hidden="true">
    <div class="image holder" /><div class="help holder" /><div class="name holder" /><div class="itemcount holder" />
  </div>
</template>
<script>
export default { name: 'SwingCardContent', props: { withHelptext: Boolean } };
</script>
<style scoped>
@keyframes placeholderAnimate { from { background-position:-650px 0; } to { background-position:650px 0; } }
.card-placeholder { padding:8px; min-width:0; }
.holder { background:linear-gradient(to right,var(--salt-hover,#ddd3) 2%,var(--salt-surface,#fff5) 18%,var(--salt-hover,#ddd3) 33%); background-size:1300px; animation:placeholderAnimate 1.7s linear infinite; }
.image { width:100%; aspect-ratio:1; border-radius:6px; }
.help,.itemcount { margin-top:8px; height:1rem; border-radius:4px; }
.help { height:0; }
.name { width:80%; border-radius:4px; height:1rem; margin-top:8px; }
.with_helptext .help { height:1rem; width:70%; }
.with_helptext .name { width:100%; }
.with_helptext .itemcount { width:85%; }
@media(prefers-reduced-motion:reduce) { .holder { animation:none; } }
</style>
